module.exports = __webpack_public_path__ + "static/media/ufo.5a5a8de0.png";